export const SYNC_ENGINE_CHAT_SPACE_ACCOUNT_ID = "ee774149-e77c-5dfd-ac11-05bf520fbefd";

export const MENTION_PREFIX_NOTE = "@";
export const MENTION_PREFIX_COLLECTION = "#";
